/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import Select from "react-select";
import config from "../../config/config";
import { useSelector } from 'react-redux';
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { MESSAGE_TYPE } from "../../constants";
import axios from "axios";

import "./O2CMainComp.css";
import styles from "./O2CMainComp.module.css";
import DomainTile from "../../components/DomainTile/DomainTile";
import BarLineChartO2C from "./BarLineChartO2C";
import DashboardSection from "../../components/DashboardContainer/DashboardSection";

const { API_BASE_URL } = config;

function O2CDispatchAndBillingComp() {

  const quarterOptionss = [
    { value: "2", label: "Q1" },
    { value: "3", label: "Q2" },
    { value: "4", label: "Q3" },
    { value: "1", label: "Q4" },
  ];
 
  const quarterToMonths = {
    2: [4, 5, 6],  // Apr–Jun
    3: [7, 8, 9],  // Jul–Sep
    4: [10, 11, 12], // Oct–Dec
    1: [1, 2, 3]   // Jan–Mar
  };

  const allMonths = [
    { label: 'Jan', value: 1 },
    { label: 'Feb', value: 2 },
    { label: 'Mar', value: 3 },
    { label: 'Apr', value: 4 },
    { label: 'May', value: 5 },
    { label: 'Jun', value: 6 },
    { label: 'Jul', value: 7 },
    { label: 'Aug', value: 8 },
    { label: 'Sep', value: 9 },
    { label: 'Oct', value: 10 },
    { label: 'Nov', value: 11 },
    { label: 'Dec', value: 12 },
  ];

  const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  const location = useLocation();
  const { showPopup } = usePopupManager();

  const initialFilters = location.state || {
    entityData: null,
    yearData: null,
    quarterData: [],
    monthData: [],
  };

  const [hasApplied, setHasApplied] = useState(false);

  const [filters, setFilters] = useState(initialFilters);

  const [showDashboard, setShowDashboard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [entityOptions, setEntityOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState(allMonths);
  const [quarterOptions, setQuarterOptions] = useState(quarterOptionss);

  const [entity, setEntity] = useState(null);
  const [year, setYear] = useState(null);
  const [month, setMonth] = useState([]);
  const [quarter, setQuarter] = useState([]);

  const [dispatchTransportBill,setDispatchTransportBill] = useState([]);
  const [dispatchInsuranceClaim,setDispatchInsuranceClaim] = useState([]);
  const [dispatchPlantPart,setDispatchPlantPart] = useState([]);
  const [dispatchSalesOrder,setDispatchSalesOrder] = useState([]);

  const handleEntityChange = (selected) => {
    setEntity(selected);
    setFilters(prev => ({ ...prev, entityData: selected }));
  };

  const handleYearChange = (selected) => {
    setYear(selected);
    setFilters(prev => ({ ...prev, yearData: selected }));
  };

  const handleQuarterChange = (selected) => {
    if (selected && selected.length > 0) {
      setQuarter(selected);
      setFilters(prev => ({ ...prev, quarterData: selected }));

      const selectedMonths = selected.flatMap(q => quarterToMonths[q.value]);

      const updatedMonths = monthOptions.filter(m => selectedMonths.includes(m.value));

      setMonth(updatedMonths);
      setFilters(prev => ({
        ...prev,
        monthData: updatedMonths,
      }));
    } else {
      setQuarter([]);
      setMonth([]);
      setFilters(prev => ({...prev,quarterData: [],monthData: []}));
    }
  };

  const handleMonthChange = (selected) => {
    const updatedMonths = selected || [];
    setMonth(updatedMonths);
    setFilters(prev => ({ ...prev, monthData: updatedMonths }));
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '20px',
      flexWrap: 'wrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '50px',
      overflowY: 'auto',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: 'visible',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }),
    option: (provided) => ({
      ...provided,
      padding: '8px 12px',
    }),
  };

  const handleApply = () => {
    const entityFilterData = entity?.value || '';
    const yearFilterData = year?.value || '';
    const monthFilterData = month?.map(m => m?.value) || []; 
    const quarterData = quarter?.map(q => q?.value) || [];

    if (entityFilterData === ''){
          showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "Please select entity.",
            });
          return;
        }

    if (yearFilterData === ''){
          showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "Please select Fiscal year.",
            });
          return;
        }

    setIsLoading(true);

    const fetchDispatchTransportBill = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/O2C-dispatch-transportbill`, 
          { 
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
            selectedQuarter: quarterData,
          },
          {headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          }},
        )
        .then((response) => {
          const result = response.data;
          setDispatchTransportBill(result)
        })
      } catch (error) {
        console.error('Error fetching Dispatch Transport Bill Drilldown options:', error);
      }
    };

    const fetchDispatchInsuranceClaim = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/O2C-dispatch-insuranceclaim`, 
          { 
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
            selectedQuarter: quarterData,
          },
          {headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          }},
        )
        .then((response) => {
          const result = response.data;
          setDispatchInsuranceClaim(result)
        })
      } catch (error) {
        console.error('Error fetching Dispatch Insurance Claim Drilldown options:', error);
      }
    };

    const fetchDispatchPlantPart = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/O2C-plantpart-drilldown`, 
          { 
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
            selectedQuarter: quarterData,
          },
          {headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          }},
        )
        .then((response) => {
          const result = response.data;
          setDispatchPlantPart(result)
        })
      } catch (error) {
        console.error('Error fetching Dispatch Plant Part Drilldown options:', error);
      }
    };

    const fetchDispatchSalesOrder = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/O2C-salesorder-drilldown`, 
          { 
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
            selectedQuarter: quarterData,
          },
          {headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          }},
        )
        .then((response) => {
          const result = response.data;
          setDispatchSalesOrder(result)
        })
      } catch (error) {
        console.error('Error fetching Dispatch Sales Order Drilldown options:', error);
      }
    };

    Promise.all([fetchDispatchTransportBill(),fetchDispatchInsuranceClaim(),fetchDispatchPlantPart(),fetchDispatchSalesOrder()]).then(() => {
      setShowDashboard(true);
      setIsLoading(false);
    });
  };

  const handleReset = () => {
    setEntity(null);
    setYear(null);
    setQuarter([]);
    setMonth([]);
    setFilters({
      entityData: null,
      yearData: null,
      quarterData: [],
      monthData: [],
    });
    setShowDashboard(false);
  };

  const fetchEntityOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/O2C-entity`, {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setEntityOptions(response.data);
        });
    } catch (error) {
      console.error("Error fetching O2C-entity options:", error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/O2C-year`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setYearOptions(response.data);
      })
    } catch (error) {
      console.error('Error fetching O2C-year options:', error);
    }
  };

  useEffect(()=>{
    fetchEntityOptions();
    fetchYearOptions();
  },[]);

  useEffect(() => {

    if (entityOptions.length && quarterOptions.length && yearOptions.length && monthOptions.length) {

      if (filters.entityData?.value) {
        const ent = entityOptions.find(opt => opt.value === filters.entityData.value);
        if (ent) setEntity(ent);
      }
  
      if (filters.yearData?.value) {
        const yr = yearOptions.find(opt => opt.value === filters.yearData.value);
        if (yr) setYear(yr);
      }

      if (filters.monthData && filters.monthData.length > 0) {
        const mon = monthOptions.filter(opt =>
          filters.monthData.some(m => m.value === opt.value)
        );
        if (mon.length > 0) setMonth(mon);
      }

      if (filters.quarterData && filters.quarterData.length > 0) {
          const qtr = quarterOptions.filter(opt =>
            filters.quarterData.some(q => q.value === opt.value)
          );
          if (qtr.length > 0) setQuarter(qtr);
        }

      if (filters.entityData?.value) {
        setTimeout(() => {
          setHasApplied(true);
        }, 1000);
      }
    }
  }, [entityOptions, yearOptions,quarterOptions, monthOptions]);

  useEffect(() => {
    if (hasApplied === true ) {
      handleApply();
      setHasApplied(false);
    }
  }, [hasApplied]);

  const dispatchTransportBillDatasets = [
    {
      type: "line",
      label: "Accuracy %",
      data: dispatchTransportBill?.map((item) => item.accuracy),
      borderColor: "#90EE90",
      backgroundColor: "#90EE90",
      yAxisID: "y1",
      tension: 0.3,
      pointRadius: 5,
      // datalabels: {
      //   display: false,
      // },
    },
    {
      type: "line",
      label: "Timeliness %",
      data: dispatchTransportBill?.map((item) => item.timeliness),
      borderColor: "#800080",
      backgroundColor: "#800080",
      yAxisID: "y1",
      tension: 0.3,
      pointRadius: 8,
      // datalabels: {
      //   display: false,
      // },
    },
    {
      type: "bar",
      label: "Within SLA",
      data: dispatchTransportBill?.map((item) => item.within_sla_count),
      backgroundColor: "#0072CE",
    },
    {
      type: "bar",
      label: "Outside SLA",
      data: dispatchTransportBill?.map((item) => item.outside_sla_count),
      backgroundColor: "#FF0000",
    },
  ];

  const dispatchInsuranceClaimDatasets = [
    {
      type: "line",
      label: "Accuracy %",
      data: dispatchInsuranceClaim?.map((item) => item.accuracy),
      borderColor: "#90EE90",
      backgroundColor: "#90EE90",
      yAxisID: "y1",
      tension: 0.3,
      pointRadius: 5,
      // datalabels: {
      //   display: false,
      // },
    },
    {
      type: "line",
      label: "Timeliness %",
      data: dispatchInsuranceClaim?.map((item) => item.timeliness),
      borderColor: "#800080",
      backgroundColor: "#800080",
      yAxisID: "y1",
      tension: 0.3,
      pointRadius: 8,
      // datalabels: {
      //   display: false,
      // },
    },
    {
      type: "bar",
      label: "Within SLA",
      data: dispatchInsuranceClaim?.map((item) => item.within_sla_count),
      backgroundColor: "#0072CE",
    },
    {
      type: "bar",
      label: "Outside SLA",
      data: dispatchInsuranceClaim?.map((item) => item.outside_sla_count),
      backgroundColor: "#FF0000",
    },
  ];

  const dispatchPlantPartDatasets = [
    {
      type: "bar",
      label: "Plant Part Dispatch Invoices",
      data: dispatchPlantPart?.map((item) => item.plant_part_dispatch_invoice_pv_count),
      backgroundColor: "#0072CE",
    },
  ];

  const dispatchSalesOrderDatasets = [
    {
      type: "bar",
      label: "Sales Orders",
      data: dispatchSalesOrder?.map((item) => item.pv_sales_order_created),
      backgroundColor: "#0072CE",
    },
  ];

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Entity<span style={{ color: 'red' }}>*</span></label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={entity}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={true}
                // isMulti={true}
                // closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Fiscal Year<span style={{ color: 'red' }}>*</span></label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                onChange={handleYearChange}
                options={yearOptions}
                isSearchable={true}
                // isMulti={true}
                // closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Quarter</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={quarter}
                onChange={handleQuarterChange}
                options={quarterOptions}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                onChange={handleMonthChange}
                options={monthOptions}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status"></div>
            <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>     
          </div>
        </div>
      )}
      {showDashboard && (
      <>
        <div className="row">
          <div className="col-md-12">
            <DomainTile title="Dispatch And Billing" showBackButton={true} mainPagePath="/Order-To-Cash" detailState = {filters}/>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 mb-4">
            <DashboardSection
              title="Transporter Bill Processing"
              disableDetailView={true}
              detailPath="/Procure-To-Pay"
              infoIcondata = "Manual CSV Data"
            >
              <BarLineChartO2C
                datasets={dispatchTransportBillDatasets}
                chartData={dispatchTransportBill}
                height={250}
                minval={0}
              />
            </DashboardSection>
          </div>
          <div className="col-lg-6 mb-4">
            <DashboardSection
              title="Insurance Claim Validation (MV Insurance)"
              disableDetailView={true}
              detailPath="/Procure-To-Pay"
              infoIcondata = "Manual CSV Data"
            >
              <BarLineChartO2C
                datasets={dispatchInsuranceClaimDatasets}
                chartData={dispatchInsuranceClaim}
                height={250}
                minval={0}
              />
            </DashboardSection>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 mb-4">
            <DashboardSection
              title="Plant Part Dispatch Invoice Created"
              disableDetailView={true}
              detailPath="/Procure-To-Pay"
              infoIcondata = "SAP Data"
            >
              <BarLineChartO2C
                datasets={dispatchPlantPartDatasets}
                chartData={dispatchPlantPart}
                height={250}
                minval={0}
              />
            </DashboardSection>
          </div>
          <div className="col-lg-6 mb-4">
            <DashboardSection
              title="Sales Order Created"
              disableDetailView={true}
              detailPath="/Procure-To-Pay"
              infoIcondata = "SAP Data"
            >
              <BarLineChartO2C
                datasets={dispatchSalesOrderDatasets}
                chartData={dispatchSalesOrder}
                height={250}
                minval={0}
              />
            </DashboardSection>
          </div>
        </div>
      </>
      )}
    </>
  );
}

export default O2CDispatchAndBillingComp;